import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import Icon from 'widgets/Icon/Icon';
import { getOfferLink } from 'apps/catalogue/links';
import wa from 'apps/analytics/services/waEventEmitter';
import { pageEventFields, pageEvents } from 'apps/products/analytics';
import { msg } from 'api';

const SmartPass = (props) => {
  const { moreExclusiveOffer = {} } = props;
  const { isMoreCardCustomer, moreOffersUrl } = moreExclusiveOffer;

  const offerLink = isMoreCardCustomer
    ? moreOffersUrl
    : getOfferLink({ id: props.schemeId, type: props.type });

  return (
    <div className="bop-promotion">
      <Link
        onClick={() => wa.triggerPageEventWithDescription(pageEvents.BOP_SMART_PASS_PROMOTION_CLICKED,
          {
            [pageEventFields.CLUB_SCHEME_ID]: props.schemeId,
            [pageEventFields.OFFER_TYPE]: props.type,
          })}
        className="bop-promotion__link bop-promotion--smartPass"
        to={offerLink}
      >
        <Icon name={msg.product.smartPass.icon} />
        <p className="bop-promotion__title bop-promotion__title--strong bop-promotion__title--smartPass">
          {props.text}{' '}
        </p>
        <span className="bop-promotion__textMore">
          {props.type === 'SMART_PASS_ELIGIBLE'
            ? <>Choose&nbsp;your&nbsp;pass</>
            : <>{msg.product.smartPass.more}</>
          }
        </span>
        <Icon name="chevron-right" className="icon__action" />
      </Link>
      <div className="gn-divider gn-divider--light bop-promotion__divider" />
    </div>
  );
};

SmartPass.propTypes = {
  schemeId: PropTypes.number,
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['SMART_PASS', 'SMART_PASS_ELIGIBLE']),
  moreExclusiveOffer: PropTypes.shape({
    moreOffersUrl: PropTypes.string,
    isMoreCardCustomer: PropTypes.bool,
  }),
};

export default SmartPass;
